import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { AppRoutePath } from 'src/app/globals/app-routepath';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): boolean => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const expectedRoles = route.data['role'] as string[];

  if (!authService.isAuthenticated()) {
    router.navigate([AppRoutePath.AUTH.LOGIN]);
    return false;
  }

  const userDetails: any = authService.getUserDetails();
  const userRoles: string[] = userDetails?.userRole;

  if (expectedRoles && !expectedRoles.some((role: string) => userRoles?.includes(role))) {
    router.navigate([AppRoutePath.AUTH.LOGIN]);
    return false;
  }

  return true;
};
